import { Component } from 'react';
import { Button } from '../ui/button';

export class SkinsErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error('Skins screen failed:', error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="ps-theme-page p-6 space-y-4" role="alert" data-testid="skins-recovery">
      <h1 className="text-xl font-bold">Unable to display this game</h1>
      <p data-testid="skins-recovery-message">Your saved game is still available. Reopen it to continue.</p>
      <Button data-testid="skins-recovery-retry" onClick={() => this.setState({ failed: false })}>Reopen game</Button>
      <Button variant="outline" data-testid="skins-recovery-back" onClick={this.props.onBack}>Back to games</Button>
    </div>;
  }
}